/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GenerateReportResponse } from './GenerateReportResponse';
import {
    GenerateReportResponseFromJSON,
    GenerateReportResponseFromJSONTyped,
    GenerateReportResponseToJSON,
} from './GenerateReportResponse';

/**
 * 
 * @export
 * @interface GenerateReport200Response
 */
export interface GenerateReport200Response {
    /**
     * 
     * @type {GenerateReportResponse}
     * @memberof GenerateReport200Response
     */
    data?: GenerateReportResponse;
}

/**
 * Check if a given object implements the GenerateReport200Response interface.
 */
export function instanceOfGenerateReport200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GenerateReport200ResponseFromJSON(json: any): GenerateReport200Response {
    return GenerateReport200ResponseFromJSONTyped(json, false);
}

export function GenerateReport200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateReport200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : GenerateReportResponseFromJSON(json['data']),
    };
}

export function GenerateReport200ResponseToJSON(value?: GenerateReport200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GenerateReportResponseToJSON(value.data),
    };
}

